import {
    SET_THEME,
    SET_COLOR_SCHEME,
    SET_COMPONENT_THEME,
    SET_THEME_UPDATE_LOADING
} from "../types/typesTheme";

export const setTheme = (theme: string) => ({
    type: SET_THEME,
    payload: theme
});

export const setColorScheme = (colorScheme: string) => ({
    type: SET_COLOR_SCHEME,
    payload: colorScheme
});

export const setComponentTheme = (componentTheme: string) => ({
    type: SET_COMPONENT_THEME,
    payload: componentTheme
});

export const setThemeUpdateLoading = (loading: boolean) => ({
    type: SET_THEME_UPDATE_LOADING,
    payload: loading
});
